export default "__VITE_ASSET__Ck$70maa__"